<template>
  <v-layout row>
   <v-flex>
        <v-toolbar color="pink" dark>
          <v-icon>list</v-icon>
          <v-toolbar-title>Dashboard</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-container fluid grid-list-lg>
            <v-layout row wrap v-if="isClub">
              <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Team Registration</div>
                      <span>Register for upcoming championships.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'championship-list'}" @click="ui.champs=true" :loading="ui.champs">View Championships</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Our Teams</div>
                      <span>View your registered teams.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'team-list'}" @click="ui.teams=true" :loading="ui.teams">View Teams</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
               <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Registered Players</div>
                      <span>View all the registered players.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'player-list'}" @click="ui.players=true" :loading="ui.players">View Players</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="isAdmin">
             <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Championship Announcements</div>
                      <span>Announce upcoming championships.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'championship-list'}" @click="ui.champs=true" :loading="ui.champs">Announce now</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Team Accounts</div>
                      <span>Create and view user accounts for team.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'club-list'}" @click="ui.clubs=true" :loading="ui.clubs">View User Accounts</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card color="light-blue  darken-1" class="white--text">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">Registered Players</div>
                      <span>View all the registered players.</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn :to="{name:'player-list'}" @click="ui.players=true" :loading="ui.players">View Players</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
     </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data:function(){
    return {
      ui:{
        players:false,
        teams:false,
        champs:false,
        clubs:false
      }
    }
  },
  computed:{
    ...mapState("config",["identity"]),
    role: function() {
      return this.identity.type;
    },
    isAdmin: function() {
      return this.role == "Administrator";
    },
    isClub: function() {
      return this.role == "Club";
    },
    isAuthorized: function() {
      return !!this.identity.token;
    }
  },
  mounted:function(){
    if(!this.isAuthorized){
      this.$router.push({name:"login"});
    }
  }
};
</script>

<style>
</style>
